import { render, staticRenderFns } from "./TriggerEdit.vue?vue&type=template&id=0d9fb80f&scoped=true&"
import script from "./TriggerEdit.vue?vue&type=script&lang=js&"
export * from "./TriggerEdit.vue?vue&type=script&lang=js&"
import style0 from "./TriggerEdit.vue?vue&type=style&index=0&id=0d9fb80f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9fb80f",
  null
  
)

export default component.exports